export const allFastGamesTextContent = {
  btnText: "View More",
  allFastGamesContent: [
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_01.webp",
      gameNameText: "Plinko Win",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_02.webp",
      gameNameText: "Aviatrix",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_03.webp",
      gameNameText: "European Roulette",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_04.webp",
      gameNameText: "Aviator",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_05.webp",
      gameNameText: "Blue Slot Dice",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_06.webp",
      gameNameText: "Plinko",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_07.webp",
      gameNameText: "Coin Flip",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_08.webp",
      gameNameText: "Big Bass Crash",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_09.webp",
      gameNameText: "Jet X",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_10.webp",
      gameNameText: "lucky Jet Crash",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_11.webp",
      gameNameText: "Hot Roll Dice",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_12.webp",
      gameNameText: "Coin Flipper",
    },
  ],
  gamesFilterContent: [
    { filterNavText: "All" },
    { filterNavText: "Crash" },
    { filterNavText: "Coin Flip" },
    { filterNavText: "Dice" },
    { filterNavText: "Roulette" },
    { filterNavText: "Plinko" },
  ]
};
